import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.array.iterator.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.promise.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.object.assign.js";
import "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/core-js/modules/es.promise.finally.js";
import 'intersection-observer';
import createPage from '@/create-page';
import boostShare from '@/views/share/boost/index.vue';
createPage({
  meta: {
    fullscreen: false
  },
  component: boostShare,
  checkForbidden: false
});